import { useCallback, useEffect, useRef, useState } from 'react';

import { ContentStyle } from '@/styles/ContentStyle';

import type { TypoProps } from './types';
import Typo from './Typo';

const AnimateText = (
  props: TypoProps & {
    children: string;
    textInterval?: number;
    repeatInterval?: number;
  },
) => {
  const resetIntervalTimer = useRef<NodeJS.Timeout | null>(null);
  const animationIntervalTimer = useRef<NodeJS.Timeout | null>(null);
  const { children, textInterval = 60, repeatInterval, ...rest } = props;
  const [render, setRender] = useState(1);
  const startAnimation = useCallback(() => {
    setRender(1);
    if (!children) return;
    if (animationIntervalTimer.current) {
      clearInterval(animationIntervalTimer.current);
    }
    let len = 1;
    animationIntervalTimer.current = setInterval(() => {
      if (len > children.length) {
        if (animationIntervalTimer.current) {
          clearInterval(animationIntervalTimer.current);
        }
      } else {
        len = len + 3;
        setRender(len);
      }
    }, textInterval);
  }, [children, textInterval]);

  useEffect(() => {
    if (resetIntervalTimer.current) {
      clearInterval(resetIntervalTimer.current);
    }
    if (repeatInterval) {
      startAnimation();
      resetIntervalTimer.current = setInterval(() => {
        startAnimation();
      }, repeatInterval);
    } else {
      startAnimation();
    }
  }, [startAnimation, repeatInterval]);

  return (
    <ContentStyle>
      <Typo
        {...rest}
        dangerouslySetInnerHTML={{ __html: children?.slice(0, render) }}
      />
    </ContentStyle>
  );
};

export default AnimateText;
